import { TerminalIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import type { ChatToolCall } from '@/components/chat/chat-message.interface'
import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import { getStatusConfig } from './tool-call-status-config.helper'

export interface ToolCallHeaderCardProps {
  toolCall: ChatToolCall
}

/** Displays tool call name, status badge, tool name, and ID in a card header. */
export const ToolCallHeaderCard: React.FC<ToolCallHeaderCardProps> = ({ toolCall }): ReactNode => {
  const statusConfig = getStatusConfig(toolCall.status)
  const StatusIcon = statusConfig.icon

  return (
    <Card className="tool-call-header-card">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center justify-between text-base">
          <div className="flex items-center gap-2">
            <TerminalIcon className="size-4" />
            <span>{toolCall.friendlyName ?? toolCall.toolName}</span>
          </div>
          <Badge variant={statusConfig.variant} className="flex items-center gap-1">
            <StatusIcon className={cn('size-3', statusConfig.isAnimated && 'animate-spin')} />
            {statusConfig.label}
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="grid gap-3 text-sm">
        <div className="flex justify-between">
          <span className="text-muted-foreground">Tool Name</span>
          <span className="font-mono font-medium">{toolCall.toolName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-muted-foreground">ID</span>
          <span className="font-mono text-xs text-muted-foreground">{toolCall.id}</span>
        </div>
      </CardContent>
    </Card>
  )
}
